import type { ComponentRef, RefObject } from "react";

export const downloadFile = (
  url: string,
  anchorRef?: RefObject<ComponentRef<"a">>,
) => {
  if (!url) {
    return;
  }

  const hasTag = !!anchorRef?.current;
  const anchor = anchorRef?.current ?? document.createElement("a");

  anchor.href = url;
  anchor.setAttribute("download", "");
  if (!hasTag) {
    anchor.style.display = "none";
  }
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
};
